import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "balance-list bg-white flex flex-col text-12px xxl:text-14px overflow-hidden h-screen relative w-full font-montserrat" }
const _hoisted_2 = { class: "flex flex-col lg:flex-row align-middle lg:items-center justify-between w-full gap-y-2 gap-x-12 mt-6" }
const _hoisted_3 = { class: "text-20px text-black-lp-200 flex flex-row gap-y-2 w-full" }
const _hoisted_4 = { class: "w-1/5 whitespace-nowrap mr-4" }
const _hoisted_5 = { class: "w-1/5 whitespace-nowrap mr-4" }
const _hoisted_6 = { class: "flex flex-row flex-no-wrap whitespace-nowrap relative" }
const _hoisted_7 = { class: "flex flex-col w-full gap-y-2 px-6 py-4 shadow-balance border border-gray-lp-900 rounded-lg mt-6" }
const _hoisted_8 = /*#__PURE__*/_createVNode("p", { class: "font-montserrat font-normal text-12px xxl:text-14px text-gray-lp-300" }, " Total Saldo Tertahan ", -1)
const _hoisted_9 = { class: "flex flex-row items-center text-lg md:text-24px font-semibold gap-2 text-yellow-lp-800" }
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "text-16px text-gray-lp-600 mt-3 mb-1" }, " Saldo Anda akan dikembalikan setelah paket berhasil diterima oleh penerima (POD) ", -1)
const _hoisted_11 = { class: "overflow-auto h-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Search = _resolveComponent("Search")!
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_time_range_picker = _resolveComponent("time-range-picker")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_ModalDownload = _resolveComponent("ModalDownload")!
  const _component_DownloadRequest = _resolveComponent("DownloadRequest")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_Search, {
            onInput: _ctx.onSearch,
            onClear: () => _ctx.onSearch(''),
            value: _ctx.params.search,
            placeholder: "Cari No. STT",
            class: "flex flex-row items-center w-auto md:w-1/3"
          }, null, 8, ["onInput", "onClear", "value"]),
          _createVNode("div", _hoisted_4, [
            _createVNode(_component_CustomDropdown, {
              selectedItem: _ctx.params.statusData,
              options: _ctx.statusData,
              placeholder: "Semua Status",
              onSelect: _ctx.onSelectStatus
            }, null, 8, ["selectedItem", "options", "onSelect"])
          ]),
          _createVNode("div", _hoisted_5, [
            _createVNode(_component_CustomDropdown, {
              selectedItem: _ctx.params.codType,
              options: _ctx.codTypeData,
              placeholder: "Pilih Tipe COD",
              onSelect: _ctx.onSelectCodType
            }, null, 8, ["selectedItem", "options", "onSelect"])
          ]),
          _createVNode(_component_time_range_picker, {
            class: "w-2/6 whitespace-nowrap",
            default: "7 hari terakhir",
            startDate: _ctx.params.startDate,
            endDate: _ctx.params.endDate,
            onSelect: _ctx.setDateRange,
            minDate: _ctx.minDate,
            maxDate: _ctx.maxDate,
            onDayClick: _ctx.setDay,
            onCancelRangePick: _ctx.cancelRangePick,
            showOptions: "custom, hari ini, kemarin, 7 hari terakhir, 30 hari terakhir",
            isOptionDisabled: !_ctx.isStartDate
          }, null, 8, ["startDate", "endDate", "onSelect", "minDate", "maxDate", "onDayClick", "onCancelRangePick", "isOptionDisabled"])
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode(_component_lp_button, {
            title: "Download Laporan",
            color: "red-lp-100",
            textColor: "red-lp-100",
            onClick: _cache[1] || (_cache[1] = () => _ctx.onDownload(true)),
            disabled: false,
            iconV2: "",
            icon: "download-underscore",
            outline: ""
          })
        ])
      ]),
      _createVNode("div", _hoisted_7, [
        _hoisted_8,
        _createVNode("div", _hoisted_9, [
          _createVNode(_component_Icons, {
            name: "coin",
            class: "h-6"
          }),
          _createTextVNode(" " + _toDisplayString(_ctx.totalHoldBalanceHistory), 1)
        ])
      ]),
      _hoisted_10,
      _createVNode("div", _hoisted_11, [
        _createVNode(_component_TableV2, {
          loading: _ctx.listEntities.loading,
          columns: _ctx.columns,
          data: _ctx.listData.dataHoldBalanceHistory,
          totalColumnFreeze: 1,
          isRightFreeze: "",
          borderTop: false,
          borderBottom: false,
          onRequest: _ctx.fetchList,
          onTryAgain: _ctx.fetchList,
          isEmpty: _ctx.isEmptyList,
          errorCause: _ctx.listEntities.message,
          pinnedSubstractHeight: "415px",
          pagination: _ctx.listEntities.pagination,
          "onUpdate:pagination": _cache[2] || (_cache[2] = ($event: any) => (_ctx.listEntities.pagination = $event)),
          paginationStyle: "v3",
          paginationWidth: "w-4/5",
          iconColor: "green-lp-100 h-4"
        }, null, 8, ["loading", "columns", "data", "onRequest", "onTryAgain", "isEmpty", "errorCause", "pagination"])
      ])
    ]),
    _createVNode(_component_ModalDownload, {
      modelValue: _ctx.isDownload,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.isDownload = $event))
    }, null, 8, ["modelValue"]),
    _createVNode(_component_DownloadRequest)
  ], 64))
}